import React from "react";
import { fmtMoney } from "@/lib/api";

export const InvoiceItemsTable = ({ invoice, theme, themeName, brand }) => (
  <table className="w-full mt-12">
    <thead>
      <tr
        className={`text-left text-[10px] uppercase tracking-[0.18em] ${theme.muted} border-b ${theme.rule}`}
        style={themeName === "atelier" ? { borderColor: brand, color: brand } : undefined}
      >
        <th className="py-3 font-normal">Item</th>
        <th className="py-3 font-normal text-right">Qty</th>
        <th className="py-3 font-normal text-right">Price</th>
        <th className="py-3 font-normal text-right">Total</th>
      </tr>
    </thead>
    <tbody>
      {invoice.items.map((it, i) => (
        <tr key={`${i}-${it.description}`} className={`border-b ${theme.rule}`}>
          <td className={`py-3 text-sm ${theme.body}`}>{it.description}</td>
          <td className={`py-3 text-right font-mono text-sm ${theme.body}`}>{it.quantity}</td>
          <td className={`py-3 text-right font-mono text-sm ${theme.body}`}>{fmtMoney(it.unit_price, invoice.currency)}</td>
          <td className={`py-3 text-right font-mono text-sm ${theme.body}`}>
            {fmtMoney(it.quantity * it.unit_price, invoice.currency)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
